import { enableCompare } from "./compare";
import { enhanceArticle } from "./enhance";
import { enableLightbox, lightPlayers, pauseOtherMedia, type PlayerReport } from "./media";
import { findSections } from "./outline";

export interface ReaderHooks {
  title?: string;
  tick?: () => void;
  lightbox?: (open: boolean) => void;
  video?: (report: PlayerReport, frame: HTMLIFrameElement) => void;
}

/** Owns the resources of one mounted article document. */
export function mountReader(root: HTMLElement | Document, hooks: ReaderHooks = {}) {
  const prose = root instanceof HTMLElement && root.matches(".prose") ? [root] : Array.from(root.querySelectorAll<HTMLElement>(".prose"));
  prose.forEach((el) => enhanceArticle(el));
  const compare = enableCompare(root, hooks.tick);
  const players = lightPlayers(root, { report: hooks.video });
  const lightbox = enableLightbox(root, { open: hooks.lightbox });
  const hide = (e: Event) => {
    const target = e.target;
    if (target instanceof HTMLImageElement && !target.closest(".yt")) (target.closest("figure") ?? target).remove();
  };
  root.addEventListener("error", hide, true);
  let disposed = false;
  return {
    sections: () => prose.flatMap((el) => findSections(el, hooks.title ?? "")),
    closeLightbox: () => lightbox.close(),
    pauseMedia: () => pauseOtherMedia(root),
    dispose() {
      if (disposed) return;
      disposed = true;
      root.removeEventListener("error", hide, true);
      lightbox.dispose(); players(); compare();
    },
  };
}
